<app-progress
  data-test="engineProgress"
  class="engine-progress"
  [value]="storyLoadProgress"
  [total]="1"></app-progress>
